import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Typography,Row,Col,Card,Descriptions,Tag} from "antd";
import Testimonials from "../../../components/Testimonials";
import Footer from "../../../components/Footer";
import { Link,useParams } from "react-router-dom";
import axios from "axios";

import {
  CheckCircleOutlined,
  LoginOutlined,
  ShoppingCartOutlined,
  StarFilled,
} from "@ant-design/icons";
const { Title } = Typography;

const ViewCourse = () => {
  const { id } = useParams();
  const getcourse = useSelector((state) => state.getcourses).result.filter(
    (obj) => obj.course._id === id
  )[0];
  
  const [content, setContent] = useState(null);
  const [fetchingContent, setFetchingContent] = useState(true);

  const handleContent = async () => {
      setFetchingContent(true);
      const res = await axios.get(
        `${process.env.REACT_APP_API_ENDPOINT}/courses/getcontent?course_id=${id}`
      );
      if (res.error) {
        alert("Error while fetching course content");
      } else {
        console.log(res.data);
        setContent(res.data);
      }
      setFetchingContent(false);
      console.log(content);
    };
    useEffect(() => {
      console.log(id);
      handleContent();
  }, []);

  const tabList = [
    {
      key: "User Info",
      tab: "Course Info",
    },
    {
      key: "About Me",
      tab: "About Course",
    },
  ];

  const [activeTabKey1, setActiveTabKey1] = useState("User Info");

  const tags_colors = [
    "magenta",
    "red",
    "volcano",
    "orange",
    "gold",
    "lime",
    "green",
    "cyan",
    "blue",
    "geekblue",
    "purple",
  ];
  // const [courseData, setCourseData] = useState(null);
  
  // useEffect(() => {
  //   const data = {
  //     id: "courseId123",
  //     title: "Introduction to React",
  //     description: "This is an interactive course that teaches you how to start with React and build up to dynamic user interfaces. You’ll work with React specific concepts like JSX, components, state, props, hooks, and more. You’ll also complete 7 projects and quizzes to test your knowledge and skills.",
  //     rating: 4.5,
  //     price: "$49.99",
  //     imageUrl: "https://example.com/course-image.jpg",
  //     user: "John Doe"
  //   };
  //   setCourseData(data);
  // }, []);

  return (
    <div>
     
        <section>
          <h2 className="my-6 mx-3">
            <p className="text-blue-600 font-bold text-5xl text-center">{getcourse.course.title}</p>
          </h2>

          <p className="font-semibold p-4">{getcourse.course.description}</p>
          <Card style={{
            margin: "20px",
            borderRadius: "10px",
            borderColor:"black",
            boxShadow: "0px 4px 8px rgba(0, 0, 0.1, 0.1)",
          }}>
          {activeTabKey1 === tabList[0].key && (
                  <Descriptions title="" bordered>
                    <Descriptions.Item label="Name">
                      {getcourse.course.title}
                    </Descriptions.Item>
                    <Descriptions.Item label="Tags">
                      {getcourse.course.tags &&
                        getcourse.course.tags[0].split(",").map((t) => {
                          return (
                            <Tag
                              color={
                                tags_colors[
                                  Math.floor(Math.random() * tags_colors.length)
                                ]
                              }
                            >
                              {t}
                            </Tag>
                          );
                        })}
                    </Descriptions.Item>
                    <Descriptions.Item label="Duration">
                      {getcourse.course.duration} Weeks
                    </Descriptions.Item>
                    <Descriptions.Item label="Starting Date">
                      {getcourse.course.startDate}
                    </Descriptions.Item>
                    <Descriptions.Item label="End Date">
                      {getcourse.course.endDate}
                    </Descriptions.Item>
                    <Descriptions.Item label="Fee">
                      Rs.{getcourse.course.fee}
                    </Descriptions.Item>
                  </Descriptions>
                )}
                {activeTabKey1 === tabList[1].key && (
                  <Descriptions title="" bordered>
                    <Descriptions.Item label="Description">
                      {getcourse.course.description}
                    </Descriptions.Item>
                  </Descriptions>
                )}
          </Card>
        </section>

        <section className="mt-4">
          <Col>
            <Link to="/login">
              <button
                className="bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded-md focus:outline-none focus:ring focus:border-blue-500 w-full"
                icon={<LoginOutlined />}
                type="primary"
              >
                {" "}
                Login To Enroll
              </button>
            </Link>
          </Col>
        </section>
      
    <div className="mt-2 flex flex-col mx-auto rounded-lg bg-white shadow-[0_2px_15px_-3px_rgba(0,0,0,0.07),0_10px_20px_-2px_rgba(0,0,0,0.04)] dark:bg-neutral-700 md:max-w-xl md:flex-row">
      <div className="flex flex-col justify-center p-6 ">
        <p
          class="mb-2 text-xl font-medium text-neutral-800 ">
          <h3 className="font-semibold text-4xl">What Will You Learn</h3>
        </p>
        <ul className="pl-6 text-gray-600 flex flex-col my-3">
              <li className="flex items-center mb-2">
                <i className="bi bi-check-circle-fill text-green-500 mr-2"></i>
                Objective 1
              </li>
              <li className="flex items-center mb-2">
                <i className="bi bi-check-circle-fill text-green-500 mr-2"></i>
                Objective 2
              </li>
              <li className="flex items-center mb-2">
                <i className="bi bi-check-circle-fill text-green-500 mr-2"></i>
                Objective 3
              </li>
            </ul>
      </div>
    </div>
      
      <section className="container my-3 mt-5">
        <div>
        <p
          class="mb-2 text-xl font-medium text-neutral-800 ">
          <h3 className="font-semibold text-3xl">This Course Includes:</h3>
        </p>
        <ul className="pl-6 my-3 grid grid-cols-2 md:grid-cols-1 md:gap-y-2 lg:grid-cols-2">
          <li className="flex items-center mb-2">
            <i className="bi bi-play-btn bi-lg text-2xl text-green-500 mr-2"></i>
            <span className="font-bold">On-demand video lectures</span>
          </li>
          <li className="flex items-center mb-2">
            <i className="bi bi-file-zip bi-lg text-2xl text-purple-500 mr-2"></i>
            <span className="font-bold">Downloadable Resources</span>
          </li>
          <li className="flex items-center mb-2">
            <i className="bi bi-tablet bi-lg text-2xl text-blue-500 mr-2"></i>
            <span className="font-bold">Accessible on all devices</span>
          </li>
          <li className="flex items-center mb-2">
            <i className="bi bi-trophy bi-lg text-2xl text-yellow-500 mr-2"></i>
            <span className="font-bold">Certificate of completion</span>
          </li>
        </ul>
        </div>
      </section>




      <div className="container my-3 mt-5">
        <Row>
        <h3 className="font-semibold text-3xl">About The Instructor</h3>
        </Row>
        <div className="bg-white p-6 rounded-lg shadow">
          <div className="bg-gray-100 p-4 flex flex-row">
            <img
              src="https://www.thecodehelp.in/_next/image?url=https%3A%2F%2Fcodehelp.s3.ap-south-1.amazonaws.com%2FDSC_00088_1_755813ca78.jpg&w=640&q=100"
              alt="Team Member"
              className="w-1/3 h-auto object-cover rounded-lg mr-4"
            />
            <div className="flex flex-col">
              <h3 className=" font-bold mb-2 text-3xl">
                <span className="text-red-500">J</span>ohn Doe
              </h3>
              <p className="text-gray-800 mt-3">
                My name is John Doe and I am super-psyched that you are
                reading this! Professionally, I come from the Data Science
                consulting space with experience in finance, retail,
                transport, and other industries. One of the strongest sides of
                my teaching style is that I focus on intuitive explanations,
                so you can be sure that you will truly understand even the
                most complex topics. To sum up, I am absolutely and utterly
                passionate about Data Science and I am looking forward to
                sharing my passion and knowledge with you!
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="container my-3 mt-4 mb-auto">
        <Row>
          <h3 className="font-semibold text-3xl">Testimonials</h3>
        </Row>
        <Testimonials />
      </div>

      <section className="mt-auto"> 
      <Footer/> 
      </section>

    </div>
  );
};

export default ViewCourse;
